import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const timer = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    boundaryEventId: z
      .string()
      .describe('The boundary event that created this timer'),

    interrupting: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this boundary event cancels the parent activity'),

    fireAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this timer will trigger'),

    repeating: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this timer re-schedules after firing'),

    repeatLimit: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Maximum number of times this timer can fire (null = unlimited)',
      ),

    fireCount: z
      .number()
      .nullable()
      .optional()
      .describe('How many times this timer chain has fired'),

    status: options([
      { value: 'Active', name: 'Active' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Triggered', name: 'Triggered' },
      { value: 'Complete', name: 'Complete' },
      { value: 'Canceled', name: 'Canceled' },
    ])
      .nullable()
      .optional()
      .describe('Current state of this timer'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    token: belongsTo('Token'),

    tenant: references('Tenant'),
  })
  .describe('A scheduled timer that will trigger at a specific time')
  .as('Timer');

export { timer as timerSchema };
